module.exports = __webpack_public_path__ + "static/img/ys_4.6be4557.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coretesc/ys_4.png
// module id = uvj6
// module chunks = 1